import { T } from '@transifex/react';
import React, { useContext, useEffect } from 'react';
import { useHistory } from 'src/routing/child-router-factory';
import { PropertyContext } from '../../../../context/property-context';
import { Layout1 } from '../../../layout';

import NotificationSubscriptions from './components/NotificationSubscriptions';
import { useSmsServiceStore, TNotificationMode } from './store';

import { BreadCrumb } from '../../../layout/breadcrumb';
import { Header } from '../../../layout/header';
import { useGetToken } from '../../../../api/config';

type NotificationFlowProps = {
  mode: TNotificationMode;
};

const NotificationFlow = ({ mode }: NotificationFlowProps) => {
  const history = useHistory();
  const token = useGetToken();
  const { id: propertyId } = useContext(PropertyContext);

  useEffect(() => {
    useSmsServiceStore
      .getState()
      .initStore({ context: { propertyId, token } }, mode);
  }, [propertyId, token, mode]);

  const onBack = () => {
    history.goBack();
  };

  return (
    <Layout1
      breadcrumb={
        <BreadCrumb
          onBack={onBack}
          title={<T _str="Subscription management" />}
        />
      }
      header={<Header title={<T _str="SMS/Email service" />} />}
      mainContent={<NotificationSubscriptions />}
    />
  );
};

export default NotificationFlow;
